import styled from "styled-components";

export const IOPageWrapper = styled.div`
  .mt-24 {
    margin-top: 24px;
  }

  .empty-message {
    color: var(--text-color-muted, #888);
    font-style: italic;
    margin-top: 16px;
  }

  .section-spacer {
    height: 48px;
  }

  .field-card .ant-card-body {
    padding: 20px 24px;
  }

  .field-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 12px;
    gap: 16px;
  }

  .field-label {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--text-color, #1c1c1c);
  }

  .field-required {
    color: #ff4d4f;
    font-weight: 600;
    font-size: 16px;
    margin-left: 2px;
  }

  .field-data-type {
    color: var(--text-color-muted, #888);
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 13px;
    background-color: var(--bg-color-secondary, #f4f4f4);
    border: 1px solid var(--border-color-secondary, #e0e0e0);
    border-radius: 3px;
    padding: 1px 6px;
  }

  .field-meta {
    margin-top: 12px;
  }

  .field-meta-label {
    margin: 0 0 4px 0;
    color: var(--text-color-secondary, #949596);
    font-size: 13px;
    font-weight: 500;
  }

  .field-default {
    background-color: var(--bg-color-secondary, #fafafa);
    border: 1px solid var(--border-color-secondary, #e0e0e0);
    border-radius: 4px;
    padding: 8px 12px;
    margin: 0;
    overflow-x: auto;

    code {
      background: transparent;
      color: var(--text-color, #1c1c1c);
      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
      font-size: 13px;
    }
  }

  .description-text {
    color: var(--text-color, #1c1c1c);
    font-size: 14px;
    line-height: 170%;

    p, li, td, th, strong, em {
      color: var(--text-color, #1c1c1c);
    }
    h1, h2, h3, h4, h5, h6 {
      color: var(--text-color, #1c1c1c);
    }
    a {
      color: var(--primary-color, #1677ff);
    }
    a:hover {
      color: var(--primary-color-hover, #4096ff);
    }
    blockquote {
      color: var(--text-color-secondary, #555);
      border-left: 4px solid var(--border-color, #d9d9d9);
      background-color: var(--bg-color-secondary, #f7f7f7);
      padding: 0.5em 1em;
      margin: 0.5em 0;
    }

    code:not(.hljs) {
      background-color: var(--bg-color-secondary, #f4f4f4);
      color: var(--primary-color, #c7254e);
      border: 1px solid var(--border-color-secondary, #e0e0e0);
      border-radius: 3px;
      padding: 1px 4px;
      font-size: 0.9em;
    }

    pre {
      background: transparent;
      border: none;
      padding: 0;
      margin: 0.5em 0;
    }
    pre > div {
      background-color: var(--bg-color-secondary, #fafafa) !important;
      border: 1px solid var(--border-color-secondary, #e0e0e0) !important;
    }
    pre > div > div {
      background-color: var(--bg-color, #ffffff) !important;
    }
    pre code, pre code.hljs {
      background-color: transparent !important;
      color: var(--text-color, #1c1c1c) !important;
    }
  }
`;
